/* eslint-disable */
import reportStorage from './reportsStorage.js'

class DashboardService {
  constructor() {
    this.dashboards = new Map() 
    this.loadingStates = new Map() 
    this.preloadQueue = [] 
  }

  registerPreloadDashboards() {
    if ( reportStorage.isDataLoaded() && this.preloadQueue.length == 0 ) {
        console.log("PreLoading Dashboards...")
        this.preloadQueue = reportStorage.preloadDashboards()
        console.log("Preloading data: ", this.preloadQueue)
        this.preloadAll()
    } else {
      setTimeout(() => this.registerPreloadDashboards(), 1000)
      console.log("Waiting for data to be loaded...")
    }
  }

  getAccessToken(reportId) {
    if (reportStorage.tokenCache && reportStorage.tokenCache.expires > Date.now()) {
      return reportStorage.tokenCache.token
    }

    return reportStorage.getAccessToken(reportId)
  }

  async preloadAll() {
    const preloadPromises = this.preloadQueue.map(config => 
      this.preloadDashboard(config.reportId, config.name)
    )
    if (preloadPromises.length === 0) {
      console.log('No dashboards to preload')
      return
    }
    await Promise.allSettled(preloadPromises)
    console.log('Preloading completed')
  }

  async preloadDashboard(reportId) {
    
    if (this.loadingStates.get(reportId) === 'loading' || this.dashboards.has(reportId)) {
      return
    }

    this.loadingStates.set(reportId, 'loading')
    
    try {
      
      const dashboardComponent = await this.loadPowerBIDashboard(reportId)
      this.dashboards.set(reportId, dashboardComponent)
      this.loadingStates.set(reportId, 'loaded')
      
      console.log(`Dashboard ${reportId} preloaded successfully`)
    } catch (error) {
      console.error(`Failed to preload dashboard ${reportId}:`, error)
      this.loadingStates.set(reportId, 'error')
    }
  }

  async loadPowerBIDashboard(reportId) {
    const accessToken = await this.getAccessToken(reportId)
    const url = `https://api.powerbi.com/groups/3ddccf9f-ba6a-4ce2-8f78-8a5e15cfb780/reports/${reportId}`
    const response = await this.powerbiRequest(accessToken, url);
    return response.data;
  }

  async powerbiRequest(accessToken, path, data, additionalHeaders) {
    const config = {
      method,
      baseURL: 'https://api.powerbi.com',
      url: path,
      data,
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        ...additionalHeaders
      },
      maxRedirects: 0,
      validateStatus: (status) => status >= 200 && status < 300,
      responseType: 'json',
      timeout: 30000
    };

    try {
      return await axios(config);
    } catch (error) {
      if (error.response.status >= 300 && error.response.status < 400) {
        const location = error.response.headers.location;
        if (location && (location.includes('analysis.windows.net') || location.includes('wabi-'))) {
          console.log(`Detected regional redirect to ${location}, normalizing back to global API`);
          
          try {
            // Extract pathname and search from regional URL
            const url = new URL(location);
            const normalizedPath = url.pathname + url.search;
            
            console.log(`Retrying with normalized path: ${normalizedPath}`);
            
            // Retry with global endpoint
            return await axios({
              ...config,
              url: normalizedPath
            });
          } catch (normalizeError) {
            console.error('Failed to normalize redirect URL:', normalizeError);
            throw normalizeError;
          }
        }
      }
      throw error;
    }
  }

  getDashboard(id) {
    return this.dashboards.get(id)
  }

  getDashboardStatus(id) {
    return this.loadingStates.get(id) || 'not-loaded'
  }

  isDashboardLoaded(id) {
    return this.loadingStates.get(id) === 'loaded'
  }

  allDashboardsLoaded() {
    return Array.from(this.loadingStates.values()).every(state => state === 'loaded')
  }

  isDashboardLoading(id) {
    return this.loadingStates.get(id) === 'loading'
  }
}

export default new DashboardService()


// WEBPACK FOOTER //
// ./src/storage/dashboardStorage.js